import React from 'react';
import CellAbstract from './CellAbstract';
import _ from 'lodash';
import { CELL_TEXT_PROPS, HIGHLGHTS } from './Types';

class CellText extends CellAbstract<CELL_TEXT_PROPS, {}> {
  /**
   * Calculate highlights based on given text and highlight array of objects
   * @private
   * @param {String} text
   * @param {HIGHLGHTS []} highlights
   */
  private calculateHighlights(text:string, highlights:HIGHLGHTS[]) {
    let renderedText = '';
    let before = '';
    let after = '';
    let textBegin = 0;
    let newtextBegin = 0;
    let newtextLength = text.length;

    /**
     * elements for text highlighting
     */
    const startTag = '<span class="tp-grid-highlight">';
    const endTag = '</span>';

    highlights.forEach((highlight) => {
      let unhighlighted = text.substring(newtextBegin - textBegin, highlight.offset - textBegin);
      let highlighted = text.substring(highlight.offset - textBegin, highlight.offset + highlight.length - textBegin);
      newtextBegin = newtextBegin + unhighlighted.length + highlighted.length;
      newtextLength = newtextLength + unhighlighted.length + highlighted.length;
      before += `${unhighlighted}${startTag}${highlighted}${endTag}`;
    });
    after = text.substring(newtextBegin - textBegin, text.length);
    renderedText = `${before}${after}`;

    return renderedText;
  }
  render() {
    const {
      dataIndex,
      dataItem,
      field,
      cellConfig,
      isErrorMessageToolTip
    } = this.props;
    let tooltip = cellConfig?.tooltip;
    const additionalClassName = cellConfig?.className ? cellConfig.className : '';

    if (isErrorMessageToolTip && dataItem?.allValidation?.[field]?.errorMessage) {
      tooltip = dataItem?.allValidation?.[field]?.errorMessage;
    }

    const content = (!_.isEmpty(dataItem[`${(field || dataIndex)}Highlights`]) ? (
      <span
        className={`tp-text-ellipsis ${additionalClassName}`}
        dangerouslySetInnerHTML={{
          __html: this.calculateHighlights(dataItem[(field || dataIndex)], dataItem[`${(field || dataIndex)}Highlights`])
        }}
      >
      </span>
    ) : (
      cellConfig?.noSpan ?
        (<>
          {dataItem[(field || dataIndex)]}
        </>)
        :
        (
          <span
            className={`tp-text-ellipsis ${additionalClassName}`}
            title={tooltip as string}
          >
            {dataItem[(field || dataIndex)]}
          </span>
        )
    ));

    return this.renderCell(content, tooltip);
  }
}

export default CellText;
